import { jsx as _jsx } from "react/jsx-runtime";
export const OctopusLogoAtomComponent = ({ width, height }) => (_jsx("svg", { width: width, height: height, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("title", { children: "Octopus logo" }) }));
export default OctopusLogoAtomComponent;
